module.exports = __webpack_public_path__ + "static/media/check.2795c68f.svg";